export default "__VITE_ASSET__0eabf9e6__"